import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';


import {HttpClient, HttpParams} from '@angular/common/http';
import {Region} from '../../types/organization/region';
import {SystemType} from '../../types/common/system-type';
import {BaseRestService} from '../common/BaseRestService';

@Injectable()
export class RegionRestService extends BaseRestService {

  constructor(private http: HttpClient) {
    super('regions');
  }

  getAllRegions(type: SystemType): Observable<Region[]> {
    const params: HttpParams = new HttpParams()
      .set('type', SystemType[type]);
    return this.http.get<Region[]>(this.getEndpoint(['translations']), {params});
  }

}
